/**
 * Created by Crete on 17/6/28.
 */


import * as types from './mutation-types.js'

export default {

}



// WEBPACK FOOTER //
// ./src/vuex/actions.js